import AuthView from './containers/AuthViewContainer';

export default AuthView;
